<!--Begin::Portlet-->
<div class="m-portlet" [ngClass]="{ 'm-portlet--full-height': fullHeight }">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                    {{ title }}
                </h3>
            </div>
        </div>
        <div *ngIf="!hiddeTimeButtons" class="m-portlet__head-tools">
            <ul role="tablist" class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm">
                <li class="nav-item m-tabs__item">
                    <a
                        [class.active]="selectedDay"
                        (click)="timeChange('day')"
                        data-toggle="tab"
                        href="#m_widget2_tab1_content"
                        role="tab"
                        class="nav-link m-tabs__link"
                        i18n="@@ec49c690a160e516dc7b364fa5295c2b2ad082f0"
                    >
                        Danes
                    </a>
                </li>
                <li class="nav-item m-tabs__item">
                    <a
                        [class.active]="!selectedDay"
                        (click)="timeChange('week')"
                        data-toggle="tab"
                        href="#m_widget2_tab2_content"
                        role="tab"
                        class="nav-link m-tabs__link"
                        i18n="@@31d672458dd9e61da6f040b5f83bee1b4258ade9"
                    >
                        Teden
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div *ngIf="!height" class="m-portlet__body">
        <div *ngIf="!allData" class="m-loader m-loader--success"></div>
        <div class="tab-content">
            <div id="m_widget2_tab1_content" class="tab-pane active">
                <!--Begin::Timeline 3 -->
                <div class="m-timeline-3">
                    <div class="m-timeline-3__items">
                        <div *ngIf="allData?.length < 1" i18n="@@b4da0dfe82450ef7a439483983a19dc4bf69af06">Ni podatkov.</div>
                        <app-time-list-element
                            *ngFor="let record of allData?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)"
                            [dateTime]="record.from"
                            [primText]="record.primText"
                            [data]="record"
                            [secText]="record.secText"
                            [classColor]="record.classColor"
                            (onClick)="elementClicked($event)"
                        ></app-time-list-element>
                        <ngb-pagination
                            *ngIf="allData?.length > itemsPerPage"
                            [(page)]="currentPage"
                            [collectionSize]="allData?.length"
                            [maxSize]="5"
                            [pageSize]="itemsPerPage"
                            [directionLinks]="false"
                            class="d-flex justify-content-center align-self-end"
                        ></ngb-pagination>
                    </div>
                </div>
                <!--End::Timeline 3 -->
            </div>
        </div>
    </div>

    <div *ngIf="height" class="m-portlet__body">
        <div *ngIf="!allData" class="m-loader m-loader--success"></div>
        <div class="tab-content">
            <div [ngStyle]="{ height: height + 'px' }">
                <ng-scrollbar [sensorDebounce]="1" [visibility]="'hover'">
                    <div id="m_widget2_tab1_content" class="tab-pane active">
                        <div class="m-timeline-3">
                            <div class="m-timeline-3__items">
                                <div *ngIf="allData?.length < 1" i18n="@@b4da0dfe82450ef7a439483983a19dc4bf69af06">Ni podatkov.</div>
                                <app-time-list-element
                                    *ngFor="let record of allData"
                                    [dateTime]="record.from"
                                    [primText]="record.primText"
                                    [data]="record"
                                    [secText]="record.secText"
                                    [classColor]="record.classColor"
                                    (onClick)="elementClicked($event)"
                                ></app-time-list-element>
                            </div>
                        </div>
                    </div>
                </ng-scrollbar>
            </div>
        </div>
    </div>
</div>
<!--End::Portlet-->
